export { withErrorBoundary, useErrorHandler } from 'react-error-boundary'

export {
  AlertErrorFallback,
  CompactErrorFallback,
  ErrorAccumulatorProvider,
  ERROR_THRESHOLD,
  ErrorDetail,
  ErrorDialog,
  ErrorFallback,
  DebuggableErrorFallback,
  FullscreenErrorFallback,
  TooManyErrorsFallback,
  PlatformErrorBoundary,
  withPlatformErrorBoundary,
  withObjectErrorBoundary,
  withGroupErrorBoundary,
  withComponentErrorBoundary,
  GroupErrorBoundary,
  ObjectErrorBoundary,
  ComponentErrorBoundary,
} from './errors/components'

export type { PlatformErrorBoundaryProps } from './errors/components'

export { ErrorLevel, UIErrorCode, PagesPermission } from './errors/constants'

export * from './errors/types'

export {
  PlatformError,
  throwPlatformError,
  handlePlatformError,
  emitError,
  logError,
  createLogError,
  logDebug,
} from './errors/utils'
